import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import HavnsLogo from "../components/HavnsLogo";
import Footer from "../components/Footer";

const Manifesto = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FBF9F7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#FBF9F7]/90 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
          <HavnsLogo className="text-2xl" linkTo="/" />
        </div>
      </nav>

      {/* Content */}
      <section className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[#666] hover:text-[#1A1A1A] mb-12 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back</span>
          </button>

          <h1 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] mb-8">
            The Anti-Dating Manifesto
          </h1>

          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-[#666] leading-relaxed mb-8">
              Havns exists for one purpose: to create meaningful platonic connections 
              for single-by-choice professionals. We are not a dating platform. We never 
              will be.
            </p>

            <h2 className="font-serif text-2xl text-[#1A1A1A] mt-12 mb-4">Our Commitment</h2>
            <ul className="space-y-4 text-[#666]">
              <li>Every member joins with the explicit understanding that Havns is strictly platonic.</li>
              <li>Romantic advances of any kind are grounds for immediate removal.</li>
              <li>We verify every member through Aadhaar KYC to ensure authenticity.</li>
              <li>Our community actively reports and addresses any violations.</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1A1A] mt-12 mb-4">What We Celebrate</h2>
            <ul className="space-y-4 text-[#666]">
              <li>The choice to be single as a valid, fulfilling lifestyle.</li>
              <li>Friendships built on shared interests, not romantic potential.</li>
              <li>Travel companions who respect boundaries.</li>
              <li>Professional connections that stay professional.</li>
            </ul>

            <h2 className="font-serif text-2xl text-[#1A1A1A] mt-12 mb-4">Zero Tolerance Policy</h2>
            <p className="text-[#666] leading-relaxed">
              Any member who engages in romantic advances, inappropriate messaging, 
              or attempts to use Havns for dating purposes will be permanently banned. 
              We take this seriously because our members' trust depends on it.
            </p>

            <div className="mt-12 p-8 bg-white rounded-2xl">
              <p className="text-[#1A1A1A] font-medium text-center italic">
                "By joining Havns, I confirm my understanding and acceptance of the 
                strictly platonic nature of this community."
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer bgColor="bg-white" />
    </div>
  );
};

export default Manifesto;
